import React from 'react';

const Badge = ({item}) => {
  return (
    <div
      style={{
        padding: '11px 29px',
        backgroundColor:
          item?.category?.onlineAdvising || item === 'doing'
            ? '#EBFFED'
            : item === 'reserved'
            ? '#EDF7FF'
            : '#FFF8ED',
        color:
          item?.category?.onlineAdvising || item === 'doing'
            ? '#23C343'
            : item === 'reserved'
            ? '#30ACFF'
            : '#FF7D00',
        borderRadius: '24px',
        textAlign: 'center',
        fontSize: '14px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        whiteSpace: item === 'reserved' ? 'nowrap' : 'normal',
        width: item === 'reserved' || item === 'doing' ? '72px' : 'auto',
      }}
    >
      {item?.category?.onlineAdvising
        ? 'آنلاین'
        : item === 'reserved'
        ? 'رزرو شده'
        : item === 'doing'
        ? 'فعال'
        : 'در حال مشاوره'}
    </div>
  );
};

export default Badge;
